import { makeCurrentItemReducer } from 'utils/factory'

export default makeCurrentItemReducer('storeTemplates')
